import { Outlet, createFileRoute } from '@tanstack/react-router';

import { PublisherDetailsPage } from '../features/supply/publishers/components/PublisherDetailsPage';

export const Route = createFileRoute('/supply/publishers_/$publisherId/details')({
  component: PublisherDetailsRoute,
});

function PublisherDetailsRoute() {
  const { publisherId } = Route.useParams();
  return (
    <PublisherDetailsPage publisherId={publisherId}>
      <Outlet />
    </PublisherDetailsPage>
  );
}
